/**
 * Gradient constants - single source of truth for default gradients
 */

// Single default gradient for all entities
export const DEFAULT_GRADIENT =
  "linear-gradient(90deg, #0091EA 0%, #9B51E0 100%)";

// Legacy support - all entities use the same default gradient
export const DEFAULT_GRADIENTS = {
  TEAM: DEFAULT_GRADIENT,
  PERSON: DEFAULT_GRADIENT,
  TAG: DEFAULT_GRADIENT,
};

// Gradient attribute IDs
export const GRADIENT_ATTRIBUTES = {
  TEAM_PROFILE_BG: "teamProfileBgGradient",
  PERSON_PROFILE_BG: "personProfileBgGradient",
  TAG_PROFILE_BG: "tagProfileBgGradient",
};
